import _classCallCheck from "/Users/darrenkey/Documents/ai-lofi-frontend/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/Users/darrenkey/Documents/ai-lofi-frontend/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "/Users/darrenkey/Documents/ai-lofi-frontend/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/Users/darrenkey/Documents/ai-lofi-frontend/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "/Users/darrenkey/Documents/ai-lofi-frontend/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import { optionsFromArguments } from "../core/util/Defaults";
import { ToneAudioNode } from "../core/context/ToneAudioNode";
import { connectSignal } from "./Signal";
/**
 * A signal operator has an input and output and modifies the signal.
 */
export var SignalOperator = /*#__PURE__*/function (_ToneAudioNode) {
  _inherits(SignalOperator, _ToneAudioNode);
  function SignalOperator() {
    _classCallCheck(this, SignalOperator);
    return _possibleConstructorReturn(this, _getPrototypeOf(SignalOperator).call(this, Object.assign(optionsFromArguments(SignalOperator.getDefaults(), arguments, ["context"]))));
  }
  _createClass(SignalOperator, [{
    key: "connect",
    value: function connect(destination) {
      var outputNum = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
      var inputNum = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;
      connectSignal(this, destination, outputNum, inputNum);
      return this;
    }
  }]);
  return SignalOperator;
}(ToneAudioNode);